"use strict";

import BaseModel from "dias/core/models/baseModel";


class FoerderangebotInfo extends BaseModel {
  constructor() {
    super("/ff/v2/foerderangebote/");
  }
}

export default FoerderangebotInfo;
